<template>
    <li class="mb_header__menu_ul">
        <slot name="menu" :clickOpen="isOpen" :toggleProps="toggle"></slot>
    </li>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
